module.exports = __webpack_public_path__ + "29608eb7746fdf1f92f2b68e06267aa6.png";